import React from 'react';
import styled from 'styled-components';
import {ColoredIcon} from "../../Steps/step-parts-components/SportIconAndTitle";

const SportTitleWrapper = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    flex-basis: 392px;
    padding-left: 16px;
    height:100%;
`;

const SportName = styled.span`
    padding: 0 22px;
    font-size: 18px;
`;

const SportCount = styled.span`
    opacity: 0.6;
    font-size: 18px;
`;

type SportTitleProps = {
    sportCount?: number;
    sportName: string;
    imageUrl?: string;
    color?: string;
};


export const SportTitle = React.memo((props: SportTitleProps) => {
    const {sportCount, imageUrl, sportName, color} = props;


    return (
        <SportTitleWrapper>
            <div className="flex">
                <ColoredIcon color={color} imageUrl={imageUrl}/>
            </div>
            <SportName className='text-xl'>{sportName}</SportName>
            <SportCount className='text-xl'>{sportCount}</SportCount>
        </SportTitleWrapper>
    );
}, (prevProps, nextProps) => {
    return prevProps.sportCount === nextProps.sportCount &&
        prevProps.sportName === nextProps.sportName &&
        prevProps.imageUrl === nextProps.imageUrl &&
        prevProps.color === nextProps.color
});
